import { IDisclosure, IParticipatingOrganizationDto, IParticipatingStudyDto } from '@vivli/features/disclosures/infrastructure/interface';
import { IPageLink, IUser } from '@vivli/shared/infrastructure/interface';
import { useDisclosureFormHook } from '@vivli/features/disclosures/infrastructure/hook';
import { DisclosureStatusEnum } from '@vivli/features/disclosures/infrastructure/enum';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { FormProvider } from 'react-hook-form';
import { Observable } from 'rxjs';
import { IDataPackageHookApi } from '@vivli/shared/infrastructure/hook';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { DisclosureFormView } from './forms/disclosure-form.view';
import {useEffect} from "react";

export interface DisclosureViewProps {
    disclosure: IDisclosure;
    dataRequest: IDataRequest;
    acknowledgementText: string;
    user: IUser;
    documentsForReviewUri: string;
    documentsForFeedbackUri: string;
    onBackClick?: () => void;
    onLinkClick?: (link: IPageLink) => void;
    onSave?: (disclosure: IDisclosure) => Observable<IDisclosure>;
    onSubmit?: (disclosure: IDisclosure) => Observable<IDisclosure>;
    onChangeStatus?: (disclosure: IDisclosure, status: DisclosureStatusEnum) => Observable<IDisclosure>;
    onReviewFinalized?: (organization: IParticipatingOrganizationDto) => Observable<IDisclosure>;
    isLoading?: boolean;
    refreshApiToken?: () => Promise<string>;
    defaultTab?: string;
    reviewDocsPackageApi: IDataPackageHookApi;
    attachmentsPackageApi: IDataPackageHookApi;
    organizations: IOrganization[];
}

export const DisclosureView = ({ disclosure, ...props }: DisclosureViewProps): JSX.Element => {
    const formApi = useDisclosureFormHook(disclosure);

    useEffect(() => {
        if (!disclosure) return;

        formApi.reset(disclosure);
    }, [disclosure]);

    return (
        <FormProvider {...formApi}>
            <DisclosureFormView {...props} disclosure={disclosure} />;
        </FormProvider>
    );
};
